import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedModeService {
  private dataSubject = new BehaviorSubject<string>('');
  data$: Observable<string> = this.dataSubject.asObservable();
  themId: any;

  setMode(mode: string) {
  this.themId = localStorage.getItem('theme_id');
    if(this.themId == 2 ){
      this.dataSubject.next("dark");
    }else{
      this.dataSubject.next("light");
    }
  }
}
